var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectCardBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "392px",
    height: "657px",
    viewBox: "0 0 392 657",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "connect-card-foreground") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Site",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Large---Contact",
    transform: "translate(-599, -370)",
    fill: "#FAE9CD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Connect",
    transform: "translate(491, 223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(108, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.900765,197.454401 L391.900765,764.008749 C391.900765,785.79342 374.216686,803.478931 352.434896,803.478931 L39.4658686,803.478931 C17.6840791,803.478931 0,785.79342 0,764.008749 L0,197.454401 C98.5607812,129.165928 300.037793,132.357974 391.900765,197.454401 Z",
    id: "connect-card-foreground"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectCardBackground);
export default __webpack_public_path__ + "static/media/connect-card-background.4b33dd7498b4460385fd35ca3304ce8c.svg";
export { ForwardRef as ReactComponent };